module.exports = __webpack_public_path__ + "static/media/logo.2a3f2125.svg";